import { ToolbarDrawer as e } from "./toolbar-drawer.mjs";
import { ToolbarButton as t } from "./toolbar-button.mjs";
import { ToolbarSheetRow as n } from "./toolbar-sheet-row.mjs";
import { useState as r } from "react";
import { Popover as i, breakpointQueries as a, useMediaQuery as o } from "@systemeio/components";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/components/content-controls/toolbar-popover.tsx
var l = (e) => e === "keyboard";
function u({ asSheetRow: u = !1, children: d, disabled: f, icon: p, keepEditorFocus: m = !1, label: h, onOpenChange: g, open: _, popupClassName: v, size: y, tooltip: b = h, triggerContent: x }) {
	let [S, C] = r(!1), w = o(a.isMobile, { initializeWithValue: !1 }), T = _ ?? S, E = (e) => {
		g?.(e), _ === void 0 && C(e);
	}, D = /* @__PURE__ */ s(n, {
		closeOnClick: !1,
		disabled: f,
		icon: p,
		label: h
	});
	return w ? /* @__PURE__ */ s(e, {
		onOpenChange: E,
		open: T,
		title: h,
		trigger: u ? D : /* @__PURE__ */ s(t, {
			disabled: f,
			label: h,
			size: y,
			tooltip: b,
			children: x ?? p
		}),
		children: d
	}) : /* @__PURE__ */ c(i.Root, {
		onOpenChange: E,
		open: T,
		children: [u ? /* @__PURE__ */ s(i.Trigger, {
			disabled: f,
			render: D
		}) : /* @__PURE__ */ s(t, {
			disabled: f,
			label: h,
			render: /* @__PURE__ */ s(i.Trigger, {}),
			size: y,
			tooltip: b,
			children: x ?? p
		}), /* @__PURE__ */ s(i.Portal, { children: /* @__PURE__ */ s(i.Positioner, {
			align: "start",
			side: "bottom",
			children: /* @__PURE__ */ s(i.Popup, {
				className: v,
				initialFocus: m ? l : void 0,
				children: d
			})
		}) })]
	});
}
//#endregion
export { u as ToolbarPopover };
